<template>
  <div class="comboSelect">
    <el-dialog
      title="选择活动"
      :visible.sync="visible"
      class="comboSelect-dialog"
      width="680px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content">
        <div class="content_left">
          <div class="content_left_tab">
            <template v-if="source === 1">
              <div :class="{ 'content_left_tab_item': true, 'active': actLabel === 2}" @click="onLabel(2)">理疗活动</div>
              <div :class="{ 'content_left_tab_item': true, 'active': actLabel === 1}" @click="onLabel(1)">普通活动</div>
            </template>
            <template v-if="[2, 3].includes(source)">
              <div :class="{ 'content_left_tab_item': true, 'active': actLabel === 1}" @click="onLabel(1)">普通活动</div>
              <div :class="{ 'content_left_tab_item': true, 'active': actLabel === 2}" @click="onLabel(2)">理疗活动</div>
            </template>
          </div>
          <div class="content_left_list">
            <div v-for="act in actList" :key="act.cseCode" :class="{ 'left_list_item': true, 'active': act.cseCode === actInfo.number }" @click="onAct(act.cseCode)">
              <div class="left_list_item_name">{{ act.cseName }}</div>
              <div class="left_list_item_type">{{ act.cseType === 1 ? '套餐' : '任选' }}</div>
            </div>
          </div>
        </div>
        <div v-show="actInfo.number" class="content-wrap">
          <div v-if="source === 2 && actInfo.physios.length > 0" class="content-tips">
            <div class="content-tips-text">理疗活动需通过【补录处方】添加</div>
            <div class="content-tips-btn" @click="toEditPrescription">补录处方</div>
          </div>
          <div class="content-head">
            <div class="content-title">{{ actInfo.cseName }}</div>
            <div v-if="actInfo.cseType === 1" class="content-rules combo">套餐{{ actInfo.drugCount }}件{{ actInfo.price }}元</div>
            <div v-if="actInfo.cseType === 2" class="content-rules optional">任选{{ actInfo.drugCount }}件{{ actInfo.price }}元</div>
          </div>
          <div class="content-time">活动时间：{{ actInfo.startTime }} 至 {{ actInfo.endTime }}</div>
          <div class="content-qty-row">
            <div class="content-qty-row-left">
              <div class="content-qty-label">活动数量</div>
              <div class="content-qty-input-wrap">
                <div class="content-qty-input-wrap-minus" @click="actCountCalculate(-1)">-</div>
                <el-input class="content-qty-input" v-model="actInfo.count" :disabled="isDisabled" @input="actCountInputIntegerFormat" @blur="actCountInputBlur"></el-input>
                <div class="content-qty-input-wrap-plus" @click="actCountCalculate(1)">+</div>
              </div>
            </div>
            <div v-if="actInfo.cseType === 2" class="content-qty-row-right">请选{{ optionalDrugCount }}件，已选{{ optionalSelectedCount }}件</div>
          </div>
          <div v-if="actInfo.physios.length > 0" class="content-table-block">
            <el-table
              :data="actInfo.physios"
              border
              :header-cell-style="{ background: '#F7F8F9', color: '#667182' }"
              style="width: 100%">
              <el-table-column prop="drugName" label="理疗项目" min-width="240" />
              <el-table-column prop="unit" label="单位" min-width="70" align="center" />
              <el-table-column label="数量" width="110">
                <template slot-scope="{ row }">
                  <div v-if="actInfo.cseType === 2" class="table-input-wrap">
                    <div class="table-input-wrap-minus" @click="comboItemNumCalculate(row, 'itemNum', -1)">-</div>
                    <el-input class="table-input" v-model="row.itemNum" :disabled="isDisabled" @input="inputIntegerFormat($event, row, 'itemNum')"></el-input>
                    <div class="table-input-wrap-plus" @click="comboItemNumCalculate(row, 'itemNum', 1)">+</div>
                  </div>
                  <div v-if="actInfo.cseType === 1" class="table-wrap-num">{{ row.itemNum }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="actInfo.drugs.length > 0" class="content-table-block">
            <el-table
              :data="actInfo.drugs"
              border
              size="small"
              :header-cell-style="{ background: '#F7F8F9', color: '#667182' }"
              style="width: 100%">
              <el-table-column prop="drugName" label="普通商品" min-width="140" />
              <el-table-column prop="specifications" label="规格" min-width="100" />
              <el-table-column prop="unit" label="单位" width="70"/>
              <el-table-column label="数量" width="110">
                <template slot-scope="{ row }">
                  <div v-if="actInfo.cseType === 2" class="table-input-wrap">
                    <div class="table-input-wrap-minus" @click="comboItemNumCalculate(row, 'itemNum', -1)">-</div>
                    <el-input class="table-input" v-model="row.itemNum" :disabled="isDisabled" @input="inputIntegerFormat($event, row, 'itemNum')"></el-input>
                    <div class="table-input-wrap-plus" @click="comboItemNumCalculate(row, 'itemNum', 1)">+</div>
                  </div>
                  <div v-if="actInfo.cseType === 1" class="table-wrap-num">{{ row.itemNum }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :disabled="!actInfo.number || (actInfo.cseType === 2 && (optionalSelectedCount !== optionalDrugCount)) || isDisabled" @click="submit">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getCombSaleOpdList, getComboSaleInfo } from '@/api/campaign'
  export default {
    name: 'comboSelect',
    props: {
      // 来源类型：1-门诊, 2-收费, 3-补录处方
      source: {
        type: [String, Number],
        default: 1
      },
      doctorId: {
        type: [String, Number],
        default: ''
      }
    },
    data () {
      return {
        visible: false,
        actLabel: 2,
        actList: [],
        actInfo: {
          number: '',
          cseName: '',
          cseType: 1,
          drugCount: 0,
          price: 0,
          count: 1,
          startTime: '',
          endTime: '',
          physios: [],
          drugs: []
        }
      }
    },
    computed: {
      optionalDrugCount () {
        return (this.actInfo.count || 1) * this.actInfo.drugCount
      },
      optionalSelectedCount () {
        const physiosCount = this.actInfo.physios.reduce((total, item) => {
          return total + (Number(item.itemNum) || 0)
        }, 0)
        const drugsCount = this.actInfo.drugs.reduce((total, item) => {
          return total + (Number(item.itemNum) || 0)
        }, 0)
        return physiosCount + drugsCount
      },
      isDisabled () {
        let status = false
        if (this.source === 2 && this.actInfo.physios.length > 0) {
          status = true
        }
        return status
      }
    },
    methods: {
      actInfoInit () {
        this.actInfo.number = ''
        this.actInfo.cseName = ''
        this.actInfo.cseType = 1
        this.actInfo.drugCount = 0
        this.actInfo.price = 0
        this.actInfo.count = 1
        this.actInfo.startTime = ''
        this.actInfo.endTime = ''
        this.actInfo.physios = []
        this.actInfo.drugs = []
      },
      open () {
        this.actLabel = this.source === 1 ? 2 : 1
        this.visible = true
        this.getActList()
      },
      close () {
        this.visible = false
        this.actLabel = 2
        this.actList = []
        this.actInfoInit()
      },
      async getActList () {
        const res = await getCombSaleOpdList({
          labels: [this.actLabel],
          deptIds: sessionStorage.getItem('deptId') && [sessionStorage.getItem('deptId')] || [],
          doctorIds: (this.doctorId && [this.doctorId]) || [],
          pageNo: 1,
          pageSize: 999
        })
        if (res.code === 200) {
          this.actList = res.data.list || []
        }
      },
      async getActInfo () {
        const res = await getComboSaleInfo({
          cseCode: this.actInfo.number
        })
        if (res.code === 200) {
          this.actInfo.number = res.data.cseCode
          this.actInfo.cseName = res.data.cseName
          this.actInfo.cseType = res.data.cseType
          this.actInfo.drugCount = res.data.drugCount || 0
          this.actInfo.price = res.data.price || 0
          this.actInfo.count = 1
          this.actInfo.startTime = new Date(res.data.startTime).Format('yyyy-MM-dd hh:mm')
          this.actInfo.endTime = new Date(res.data.endTime).Format('yyyy-MM-dd hh:mm')
          this.actInfo.physios = res.data.physios && res.data.physios.map(v => {
            v['itemNum'] = 0
            if (res.data.cseType === 1) {
              v.itemNum = v.quantity
            }
            return v
          }) || []
          this.actInfo.drugs = res.data.drugs && res.data.drugs.map(v => {
            v['itemNum'] = 0
            if (res.data.cseType === 1) {
              v.itemNum = v.quantity
            }
            return v
          }) || []
        }
      },
      onLabel (label) {
        this.actLabel = label
        this.actInfoInit()
        this.getActList()
      },
      onAct (code) {
        this.actInfo.number = code
        this.getActInfo()
      },
      actCountInputIntegerFormat(value) {
        this.actInfo.count = String(value || '').replace(/[^\d]/g, '')
      },
      actCountInputBlur () {
        if (!this.actInfo.count || this.actInfo.count < 1) {
          this.actInfo.count = 1
        }
        if (this.actInfo.cseType === 1) {
          this.actInfo.physios.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
          this.actInfo.drugs.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
        }
      },
      actCountCalculate (value) {
        if (this.isDisabled) {
          return
        }
        let count = this.actInfo.count + Number(value)
        if (count < 1) {
          count = 1
        }
        this.actInfo.count = count
        if (this.actInfo.cseType === 1) {
          this.actInfo.physios.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
          this.actInfo.drugs.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
        }
      },
      inputIntegerFormat (value, row, key) {
        row[key] = String(value || '').replace(/[^\d]/g, '')
      },
      comboItemNumCalculate (row, key, value) {
        if (this.isDisabled) {
          return
        }
        let num = Number(row[key]) + Number(value)
        if (num < 0) {
          num = 0
        }
        row[key] = num
      },
      submit () {
        this.$emit('submit', JSON.parse(JSON.stringify(this.actInfo)))
      },
      // 跳转至补录处方
      toEditPrescription () {
        this.close()
        this.$emit('toEditPrescription')
      }
    }
  }
</script>

<style lang="less" scoped>
  .comboSelect-dialog /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .comboSelect-dialog /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .comboSelect-dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 12px;
  }

  .comboSelect-dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .comboSelect-dialog /deep/ .el-dialog__footer {
    padding: 0;
  }

  .content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 440px;
    overflow: hidden;
  }

  .content_left {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 200px;
    height: 100%;
    background-color: #FAFBFC;
    border-right: 1px solid #E0E0E0;
    overflow: hidden;
  }

  .content_left_tab {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #E0E0E0;
  }

  .content_left_tab_item {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 14px;
    color: #667182;
    cursor: pointer;
  }

  .content_left_tab_item.active {
    font-weight: 600;
    color: #000000;
  }

  .content_left_tab_item.active::after {
    content: '';
    position: absolute;
    z-index: 2;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #1890FF;
  }

  .content_left_tab_item + .content_left_tab_item {
    margin: 0 0 0 24px;
  }

  .content_left_list {
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .left_list_item {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px 0 16px;
    width: 100%;
    height: 34px;
    cursor: pointer;
  }

  .left_list_item.active {
    background-color: #E8F4FF;
  }

  .left_list_item_name {
    flex-grow: 1;
    min-width: 0px;
    line-height: 20px;
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .left_list_item_type {
    flex-shrink: 0;
    margin: 0 0 0 4px;
    line-height: 20px;
    font-size: 12px;
    color: #667182;
    white-space: nowrap;
  }

  .content-wrap {
    box-sizing: border-box;
    flex-grow: 1;
    padding: 16px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .content-tips {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: -16px -16px 16px -16px;
    padding: 0 16px;
    width: calc(100% + 32px);
    height: 40px;
    background-color: #FFFDE9;
  }

  .content-tips-text {
    font-size: 13px;
    color: #667182;
  }

  .content-tips-btn {
    padding: 0 10px;
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    color: #667182;
    background-color: #FFFFFF;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    cursor: pointer;
  }

  .content-head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .content-title {
    line-height: 22px;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
  }

  .content-rules {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 6px;
    padding: 0 8px;
    height: 24px;
    font-size: 13px;
    border-radius: 2px;
  }

  .content-rules.combo {
    color: #1890FF;
    background-color: #E8F4FF;
  }

  .content-rules.optional {
    color: #29C01B;
    background-color: #E2F8E0;
  }

  .content-time {
    margin: 4px 0 0 0;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
  }

  .content-qty-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .content-qty-row-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .content-qty-label {
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .content-qty-input-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 12px;
  }

  .content-qty-input-wrap-minus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 18px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 2px 0 0 2px;
    cursor: pointer;
    user-select: none;
  }

  .content-qty-input-wrap-plus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 20px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 0 2px 2px 0;
    cursor: pointer;
    user-select: none;
  }

  .content-qty-input {
    margin: 0 -1px;
    width: 48px;
    height: 24px;
  }

  .content-qty-input /deep/ .el-input__inner {
    padding: 0 6px;
    height: 24px;
    text-align: center;
  }

  .content-qty-row-right {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .content-table-block {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .table-input-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .table-input-wrap-minus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 18px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 2px 0 0 2px;
    cursor: pointer;
    user-select: none;
  }

  .table-input-wrap-plus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 20px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 0 2px 2px 0;
    cursor: pointer;
    user-select: none;
  }

  .table-input {
    margin: 0 -1px;
    width: 40px;
    height: 24px;
  }

  .table-input /deep/ .el-input__inner {
    padding: 0 6px;
    height: 24px;
    text-align: center;
  }

  .table-wrap-num {
    font-size: 14px;
    color: #000000;
  }

  .footer {
    box-sizing: border-box;
    padding: 16px 18px;
    width: 100%;
    border-top: 1px solid #E0E0E0;
  }
</style>